import { comics } from "@/mocks/comics";

const topWorks = comics.filter((c) => c.isTop);

export default function TopWorks() {
  return (
    <section id="top" className="relative overflow-hidden bg-foreground-950 py-16 text-background-50 md:py-24">
      <div className="pointer-events-none absolute -right-20 -top-24 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl"></div>
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-72 w-72 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-sm font-semibold text-secondary-300">
              <i className="ri-vip-crown-fill"></i> 霸榜作品
            </span>
            <h2 className="mt-3 font-heading text-3xl text-white md:text-4xl">长期霸榜的人气之作</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/70">
              连续多周稳居榜单前列的连载，代表当下最火热的人气风向。点击卡片即可查看追更进度。
            </p>
          </div>
          <a
            href="#updates"
            className="whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            查看全部霸榜
          </a>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4">
          {topWorks.map((comic, i) => {
            const progress = Math.round((comic.latestChapter / comic.totalChapters) * 100);
            return (
              <article
                key={comic.id}
                className="manga-card-hover group overflow-hidden rounded-2xl bg-background-50 text-foreground-950"
              >
                <div className="relative aspect-[3/4] w-full overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title} 霸榜人气连载漫画封面`}
                    title={`${comic.title} 人气连载霸榜作品`}
                    className="manga-art h-full w-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <span className="absolute left-3 top-3 rounded-full bg-secondary-500 px-2.5 py-1 text-xs font-bold text-background-50">
                    #{i + 1} 霸榜
                  </span>
                  <div className="absolute bottom-3 left-3 right-3">
                    <p className="truncate text-base font-bold text-white">{comic.title}</p>
                    <div className="mt-1 flex items-center justify-between text-xs text-white/85">
                      <span>{comic.latestChapter} 话</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-secondary-400"></i> {comic.rating}
                      </span>
                    </div>
                    <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-white/25">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-secondary-400 to-primary-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}